import { WORD, RTL_PATTERN } from '../constants'
import { measureText } from '../utils'

import TextRule from './TextRule'

export default class Word extends TextRule {
  constructor(text) {
    super(text)
    this.isRTL = RTL_PATTERN.test(text)
  }

  getType() {
    return WORD
  }

  getWidth() {
    if (this.width !== null) {
      return this.width
    }
    this.width = measureText(this.text, this.font).width
    return this.width
  }

  draw(ctx, fontMetrics) {
    ctx.fillText(this.text, this.x, this.y + this.lineHeight / 2 + fontMetrics.baselineOffset)

    this.drawDecoration(ctx, fontMetrics)
  }
}
